import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getPayStatus, getChargeRefundCount } from '@/api/module/index';
import { Dialog, Toast } from "vant";
import { updateCancelCompany } from '@/api/module/user';
import { getPaymentUrlByBookedNo } from "@/api/module";
import { transactions, refundOrder as _refundOrder, queryRefundOrder } from "@/api/module/auth";
import { encrypt } from "@/assets/utils/cryptoUtil";
export default {
  name: "Company",
  // extends:WechatAuth,
  data: function data() {
    return {
      active: 0,
      companys: [],
      showMoney: window.g.VUE_APP_SHOW_MONEY,
      VUE_APP_HIDE_MONEY_COMPANYIDS: window.g.VUE_APP_HIDE_MONEY_COMPANYIDS,
      VUE_APP_ISWECHAT: window.g.VUE_APP_ISWECHAT,
      VUE_APP_PAY_ENABLE: window.g.VUE_APP_PAY_ENABLE,
      VUE_APP_PAY_TYPE: window.g.VUE_APP_PAY_TYPE,
      noDataShow: false,
      goAnswerPopShow: window.g.VUE_APP_GO_ANSWER_POP_SHOW,
      // 控制是否显示前往答题的弹框
      answerShow: false,
      // 需要答题的个数
      tipsTile: '',
      tipsText: '',
      payLoading: false,
      refundloading: false,
      payRefreshLoading: false,
      paySerialno: ''
    };
  },
  props: {
    item: {}
  },
  filters: {
    filterSettlement: function filterSettlement(value) {
      switch (value) {
        case '0':
          {
            return '未付款';
            break;
          }

        case '1':
          {
            return '已付款';
            break;
          }

        case '2':
          {
            return '部分结算';
            break;
          }

        default:
          {
            return '';
          }
      }
    },
    filterDatetime: function filterDatetime(val) {
      return val.substring(0, 10);
    }
  },
  methods: {
    //计算showMoney的值
    getsingleShowMoney: function getsingleShowMoney(companyID) {
      var singleShowMoney = true;

      if (this.showMoney) {
        if (Array.isArray(this.VUE_APP_HIDE_MONEY_COMPANYIDS)) {
          if (companyID != undefined && this.VUE_APP_HIDE_MONEY_COMPANYIDS.includes(companyID.substring(0, 4))) {
            singleShowMoney = false;
          }
        }
      }

      return singleShowMoney;
    },
    toOrder: function toOrder(item) {
      this.$router.push({
        name: 'companyOrder',
        query: {
          item: JSON.stringify(item)
        }
      });
    },
    toOrderUpdateDate: function toOrderUpdateDate(item) {
      this.$router.push({
        name: 'companyOrderUpdateDate',
        query: {
          item: JSON.stringify(item)
        }
      });
    },
    toDetail: function toDetail(item) {
      console.log(item);
      this.$router.push({
        name: 'orderDetail',
        query: {
          bookedno: item.bookedNo,
          settlement: item.settlementMode,
          status: item.status,
          orderno: item.orderNo,
          companyid: item.companyID
        }
      });
    },
    done: function done() {
      Dialog.alert({
        title: '提示',
        message: '已完成此次预约'
      }).then(function () {});
    },
    toHome: function toHome() {
      this.$router.push({
        name: 'home'
      });
    },
    toUserinfo: function toUserinfo() {
      this.$router.push({
        name: 'userinfo'
      });
    },
    toOrders: function toOrders() {
      this.$router.push({
        name: 'orders'
      });
    },
    filterCheckDate: function filterCheckDate(datestr) {
      var char = "-";
      var nowDate = new Date(datestr);
      var day = nowDate.getDate();
      var month = nowDate.getMonth() + 1; //注意月份需要+1

      var year = nowDate.getFullYear(); //补全0，并拼接

      console.log(year + char + this.completeDate(month) + char + this.completeDate(day));
      return year + char + this.completeDate(month) + char + this.completeDate(day);
    },
    getNow: function getNow() {
      var char = "-";
      var nowDate = new Date();
      var day = nowDate.getDate();
      var month = nowDate.getMonth() + 1; //注意月份需要+1

      var year = nowDate.getFullYear(); //补全0，并拼接

      console.log(year + char + this.completeDate(month) + char + this.completeDate(day));
      return year + char + this.completeDate(month) + char + this.completeDate(day);
    },
    //补全0
    completeDate: function completeDate(value) {
      return value < 10 ? "0" + value : value;
    },
    //取消预约
    del: function del(item) {
      var _this2 = this;

      //取消确认
      Dialog.confirm({
        title: '取消确认',
        message: '确认取消预约吗？'
      }).then(function () {
        // on confirm
        var user = JSON.parse(localStorage.getItem("loginuser"));
        var _this = _this2;
        var param = {
          bookedtype: item.bookedType,
          patientid: user.patientid,
          bookedno: item.bookedNo,
          checkdate: item.checkDate,
          sexid: item.sexID,
          companyid: item.companyID,
          companytime: item.companyTime,
          timeslot: item.timeSlot,
          bookednos: item.bookedNos,
          enterqueue: item.enterQueue,
          institutionid: window.g.VUE_APP_INSTITUTIONID
        };
        updateCancelCompany(param).then(function (res) {
          if (res.code == 200) {
            if (res.data == 0) {
              Toast.fail(res.msg);
            } else {
              Toast(res.msg);
              setTimeout(function () {
                _this.$parent.getOrders();
              }, 1000);
            }
          }
        });
      }).catch(function () {// on cancel
      });
    },
    dialogMemo: function dialogMemo(memoTxt) {
      Dialog.alert({
        message: memoTxt
      }).then(function () {// on close
      });
    },
    pay: function pay(serialno, amout, packagename) {
      this.$parent.paySerialno = serialno;
      this.$parent.isOrder = false; //跳转支付链接

      if (this.VUE_APP_PAY_TYPE == "0") {
        this.payLoading = true;
        this.toPayPage(serialno);
      } //JSAPI调起支付
      else if (this.VUE_APP_PAY_TYPE == "2") {
        this.jsApiPay(amout, packagename, serialno);
      } //his收费
      else if (this.hisChargeOpen == "1") {
        Dialog.alert({
          message: "暂未支持，请至体检中心完成支付"
        });
      }
    },
    jsApiPay: function jsApiPay(amout, packagename, attach) {
      console.log('调用微信JSAPI支付');
      console.log(this.VUE_APP_ISWECHAT);

      if (this.VUE_APP_ISWECHAT == "1") {
        var userinfo = JSON.parse(sessionStorage.getItem("userinfo"));
        this.openid = userinfo.openid;
        console.log(this.openid);
        var vm = this;

        if (this.openid == undefined || this.openid == '') {
          alert("缺少openid参数，无法完成支付");
          return;
        }

        var params = {
          type: 'jsapi',
          //支付类型
          openid: this.openid,
          //公众号id
          total: parseFloat(amout) * 100,
          //订单金额
          attach: attach,
          //回调通知原样传递参数
          description: packagename + '体检费' //商品描述信息

        };
        transactions(params).then(function (res) {
          var data = {
            appId: res.signMap.appId,
            //公众号id，必传
            nonceStr: res.signMap.nonceStr,
            //随机串，必传
            timeStamp: res.signMap.timeStamp,
            //时间戳，必传
            package: "prepay_id=" + res.prepay_id,
            //必传
            signType: res.signMap.signType,
            //微信签名方式
            paySign: res.signMap.paySign //微信签名

          }; // 下面是解决WeixinJSBridge is not defined 报错的方法

          if (typeof WeixinJSBridge === 'undefined') {
            // 微信浏览器内置对象。参考微信官方文档
            if (document.addEventListener) {
              setTimeout(function () {
                document.addEventListener('WeixinJSBridgeReady', vm.onBridgeReady(data), false);
              }, 1000);
            } else if (document.attachEvent) {
              setTimeout(function () {
                document.attachEvent('WeixinJSBridgeReady', vm.onBridgeReady(data));
                document.attachEvent('onWeixinJSBridgeReady', vm.onBridgeReady(data));
              }, 1000);
            }
          } else {
            console.log('准备调用微信支付');
            setTimeout(function () {
              vm.onBridgeReady(data);
            }, 1000);
          }
        }).catch(function (err) {
          Dialog.alert({
            message: "统一下单返回出错：" + err
          }).then(function () {});
        });
      } else {
        Dialog.alert({
          message: "openid不存在，无法完成支付"
        });
      }
    },
    onBridgeReady: function onBridgeReady(data) {
      console.log('调用微信支付WeixinJSBridge');
      console.log('参数', data);
      var vm = this;
      WeixinJSBridge.invoke('getBrandWCPayRequest', {
        // 下面参数内容都是后台返回的
        'appId': data.appId,
        // 公众号名称，由商户传入
        'timeStamp': data.timeStamp,
        // 时间戳
        'nonceStr': data.nonceStr,
        // 随机串
        'package': data.package,
        // 预支付id
        'signType': data.signType,
        // 微信签名方式
        'paySign': data.paySign // 微信签名

      }, function (res) {
        // 使用以上方式判断前端返回,微信团队郑重提示：res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
        if (res.err_msg === 'get_brand_wcpay_request:ok') {
          Dialog.alert({
            message: '支付成功'
          }).then(function () {
            vm.$parent.payRefreshLoading = true;
            vm.$parent.currentSecond = 1;
            vm.$parent.endRate = 6.6;
            vm.$parent.timer = setInterval(function () {
              setTimeout(function () {
                vm.$parent.payStatusRefresh();
              }, 0);
            }, 2000);
          });
        } else {
          Dialog.alert({
            message: '支付失败'
          }).then(function () {});
        }
      });
    },
    //跳转到支付页面
    toPayPage: function toPayPage(bookedno) {
      var _this3 = this;

      var params = {
        bookedno: encrypt(bookedno)
      };
      getPaymentUrlByBookedNo(params).then(function (res) {
        if (res.code == 200) {
          window.location.href = res.data;
        } else {
          _this3.payLoading = false;
          Toast.fail("支付失败" + res.data);
        }
      });
    },
    //申请退款
    refundOrder: function refundOrder(item) {
      var _this = this;

      this.$parent.refundloading = true;
      _this.$parent.currentSecond = 1;
      _this.$parent.endRate = 6.6;
      var params = {
        transactionId: item.chargeCustom.transactionno,
        //微信订单号
        refundFee: parseFloat(item.chargeCustom.amount) * 100,
        //退款金额
        outRefundNo: item.chargeCustom.chargeno //退款单号

      };

      _refundOrder(params).then(function (res) {
        _this.$parent.timer = setInterval(function () {
          setTimeout(function () {
            _this.$parent.refundStatusRefresh(item.chargeCustom.chargeno);
          }, 0);
        }, 1000);
      });
    }
  }
};